'use client';

import { css } from '@repo/pandacss/styled-system/css';
import { dynamicWithRetry } from '@repo/ui-v2/DynamicWithRetry';
import { Props as RevalidateLinkProps } from '@repo/ui-v2/RevalidateLink';
import type { WPAdminBarProps } from '@repo/ui-v2/WPAdminBar';
import { useHasWPSession } from './hook';

const RevalidateLink = dynamicWithRetry<RevalidateLinkProps>(
  () =>
    import('@repo/ui-v2/RevalidateLink').then(mod => ({
      default: mod.default,
    })),
  {
    componentName: 'RevalidateLink',
    ssr: false,
  },
);

const UpdateAbsmartlyContextLink = dynamicWithRetry<Record<string, never>>(
  () =>
    import('@repo/ui-v2/UpdateAbsmartlyContextLink').then(mod => ({
      default: mod.default,
    })),
  {
    componentName: 'UpdateAbsmartlyContextLink',
    ssr: false,
  },
);

const WPAdminBar = dynamicWithRetry<WPAdminBarProps>(
  () =>
    import('@repo/ui-v2/WPAdminBar').then(mod => ({
      default: mod.default,
    })),
  {
    componentName: 'WPAdminBar',
    ssr: false,
  },
);

export type PageType = 'Roundup' | 'Review' | 'Calculator';

type Props = {
  id: string;
  pageType?: PageType;
  lastModified?: string;
};

export default function WordpressEditWrapper({ id, pageType, lastModified }: Props) {
  const { hasWPSession } = useHasWPSession();

  if (hasWPSession && pageType) {
    return (
      <>
        <WPAdminBar wpId={id} />
        {lastModified && (
          <span
            className={css({
              position: '[absolute]',
              right: '0',
              top: '[180px]',
              padding: '2',
              marginRight: '2',
              textStyle: 'textSmall',
            })}
          >
            Last modified at {lastModified}
          </span>
        )}
        <RevalidateLink label={`Refresh ${pageType}`} />
        <UpdateAbsmartlyContextLink />
      </>
    );
  }
  return null;
}
